export type DashboardGroupMeta = {
    id      : string
    title   : string
    icon    : string
}

export const dashboardGroupsMeta: DashboardGroupMeta[] = [
    { id: "tasks",                   title: "Tasks",                      icon: "i5-tasks-light" },
    { id: "time-reporting",          title: "Time Reporting",             icon: "i5-my-time" },
    { id: "scrum-agile",             title: "Scrum & Agile",              icon: "i5-gantt-light" },
    { id: "resource-planning",       title: "Resource Planning",          icon: "i5-workload-light" },
    { id: "efforts-distribution",    title: "Efforts Distribution",       icon: "i5-pie-chart" },
    { id: "hr",                      title: "HR",                         icon: "i5-attendance" },
    { id: "behavior",                title: "Behavior",                   icon: "i5-tachometer" },
    { id: "collaboration-processes", title: "Collaboration and Processes", icon: "i5-users" },
    { id: "reports",                 title: "Reports",                    icon: "i5-chart-bar" },
]
